import { buildRouteHead } from "@/lib/seo/routeHead";
import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/es/caso-estudio/$slug")({
  head: () => buildRouteHead("/es/caso-estudio/$slug", { noIndex: true }),
  beforeLoad: () => {
    throw redirect({ to: "/es/casos-de-exito", replace: true });
  },
});
